import { render, staticRenderFns } from "./veiculos.vue?vue&type=template&id=4baab8ee"
import script from "./veiculos.vue?vue&type=script&lang=js"
export * from "./veiculos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports